import React from "react";
import { Modal, ModalHeader } from "../../globalComponents/ui/Modal";
import { PrimaryButton } from "../../globalComponents/ui/Button";

/**
 * Tells a non-admin that running an analysis needs administrator access.
 *
 * @param {{show: boolean, onClose: function}} props - Visibility and dismissal.
 * @returns {JSX.Element} The modal.
 *
 * @remarks
 * Shown in place of an action rather than instead of the page. Every role can
 * reach the feature and see what it does; only running one is restricted, and
 * that restriction is enforced by the API rather than by this dialog.
 */
const ContactAdminModal = ({ show, onClose }) => (
  <Modal show={show} onClose={onClose} maxWidth={460}>
    <ModalHeader
      icon="fas fa-lock"
      title="Administrator access required"
      onClose={onClose}
    />
    <div className="aica-modal-body">
      <p>
        You need administrator access to run a competitor analysis. Please
        contact your admin to request access, or ask them to run it for you.
      </p>
    </div>
    <div className="aica-modal-footer">
      <PrimaryButton type="button" onClick={onClose}>
        Got it
      </PrimaryButton>
    </div>
  </Modal>
);

export default ContactAdminModal;
